/* eslint-disable import/no-cycle */
import axiosIns, { axiosInsNoEnc, axiosDefault } from '@/libs/axios'
import { requestApi } from '@/libs/secret'

/* eslint-disable no-return-assign */
export default {
  namespaced: true,
  state: {
    creditBalance: '0.00',
    amountOptions: [
      {
        id: 1,
        amount: '500.000',
      },
      {
        id: 2,
        amount: '1.000.000',
      },
      {
        id: 3,
        amount: '5.000.000',
      },
      {
        id: 4,
        amount: '10.000.000',
      },
      {
        id: 5,
        amount: '15.000.000',
      },
      {
        id: 6,
        amount: '20.000.000',
      },
    ],
    isWaitingApproval: true,
    statusPayment: false,
    currentInvoiceNo: '',
    dataTopup: {
      page: 1,
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'invoice_no', label: 'Invoice No.', sortable: true },
        { key: 'due_date', label: 'Due Date.', sortable: true },
        { key: 'total', label: 'Total', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: '' },
      ],
      status: [
        {
          1: 'Unpaid', 2: 'Waiting Approval', 3: 'Paid', 4: 'Rejected', 5: 'Cancelled',
        },
        {
          1: 'warning', 2: 'warning', 3: 'success', 4: 'danger', 5: 'danger',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
      startdate: '',
      enddate: '',
    },
  },
  getters: {
    getAmountOptions: state => state.amountOptions,
    getHistoryTopupItem: state => state.dataTopup.items,
    getHistoryTopupField: state => state.dataTopup.fields,
    getHistoryTopupStatus: state => state.dataTopup.status,
    getCurrentPage: state => state.dataTopup.items.current_page,
    getSortBy: state => state.dataTopup.sortBy,
    getSortDesc: state => state.dataTopup.sortDesc,
    getSearch: state => state.dataTopup.search,
    getStartDate: state => state.dataTopup.startdate,
    getEndDate: state => state.dataTopup.enddate,
    getIsWaitingApproval: state => state.isWaitingApproval,
    getItemData: state => state.dataTopup.items.data,
  },
  mutations: {
    SET_DATA_INVOICE_ITEM: (state, value) => (value ? (state.dataInvoice.items = value) : (state.dataInvoice.items = [])),
    SET_DATA_HISTORY_TOPUP: (state, value) => (value ? (state.dataTopup.items = value) : (state.dataTopup.items = [])),
    SET_DATA_CREDIT_BALANCE: (state, value) => (value ? (state.creditBalance = value) : (state.creditBalance = '0.00')),
    SET_DATA_AMOUNT_OPTIONS: (state, value) => (value ? (state.amountOptions = value) : (state.amountOptions = [])),
    SET_DATA_WAITING_APPROVAL: (state, value) => (value ? (state.isWaitingApproval = value) : (state.isWaitingApproval = false)),
    SET_DATA_STATUS_PAYMENT: (state, value) => (value ? (state.statusPayment = value) : (state.statusPayment = false)),
    SET_DATA_CURRENT_INVOICE_NO: (state, value) => (value ? (state.currentInvoiceNo = value) : (state.currentInvoiceNo = null)),
    SET_TOPUP_CURRENT_PAGE: (state, value) => (value ? (state.dataTopup.items.current_page = value) : (state.dataTopup.items.current_page = 1)),
    SET_ITEM_DATA: (state, value) => (value ? (state.dataTopup.items.data = value) : (state.dataTopup.items.data = [])),
    SET_TOPUP_SORT_BY: (state, value) => (value ? (state.dataTopup.sortBy = value) : (state.dataTopup.sortBy = '')),
    SET_TOPUP_SORT_DESC: (state, value) => (value ? (state.dataTopup.sortDesc = value) : (state.dataTopup.sortDesc = false)),
    SET_TOPUP_SEARCH: (state, value) => (value ? (state.dataTopup.search = value) : (state.dataTopup.search = '')),
    SET_STARTDATE: (state, value) => (value ? (state.dataTopup.startdate = value) : (state.dataTopup.startdate = '')),
    SET_ENDDATE: (state, value) => (value ? (state.dataTopup.enddate = value) : (state.dataTopup.enddate = '')),
  },
  actions: {
    clearTable({ commit }) {
      commit('SET_TOPUP_CURRENT_PAGE')
      commit('SET_TOPUP_SORT_BY')
      commit('SET_TOPUP_SORT_DESC')
      commit('SET_TOPUP_SEARCH')
    },
    getDataList({ commit, rootState, getters }) {
      const desc = (getters.getSortDesc) ? 'desc' : 'asc'
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getCurrentPage}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}&status=${getters.getStatusApprove}&startdate=${getters.getStartDate}&enddate=${getters.getEndDate}`)
        axiosIns.get(`topup/trxList?req=${queryParam.req}`, { headers }).then(response => {
          commit('SET_DATA_HISTORY_TOPUP', response.data)
          commit('SET_ITEM_DATA', response.data.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    setCreditBalance({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('account/creditBalance', { headers }).then(response => {
          commit('SET_DATA_CREDIT_BALANCE', response.data.data.saldo)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    newTopup({ commit, rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.post('topup/newTrx', {
          amount: payload.amount,
        }, { headers }).then(response => {
          commit('SET_DATA_WAITING_APPROVAL', true)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getAmountOptions({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('topup/amountOption', { headers }).then(response => {
          commit('SET_DATA_AMOUNT_OPTIONS', response.data.data)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-unused-vars
    waitingPaymentTopup({ commit, rootState }) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.get('topup/checkTransaction', { headers }).then(response => {
          const status = (response.data.data.status === 1 || response.data.data.status === 2) ?? (false)
          commit('SET_DATA_WAITING_APPROVAL', status)
          commit('SET_DATA_STATUS_PAYMENT', response.data.data.status)
          commit('SET_DATA_CURRENT_INVOICE_NO', response.data.data.invoice_no)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // eslint-disable-next-line no-unused-vars
    uploadProofTopup({ commit, rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      let formData = new FormData()
      formData.append('invoice_no', payload.invoice_no)
      formData.append('upload_payment_proof', payload.upload_payment_proof)
      return new Promise((resolve, reject) => {
        axiosInsNoEnc.post('topup/paymentProof', formData, { headers }).then(response => {
          commit('SET_DATA_STATUS_PAYMENT', 2)
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    cancelPaymentTopup({ rootState }, payload) {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        axiosIns.post('topup/cancel', {
          invoice_no: payload.invoice_no,
        }, { headers }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    downloadTable({ getters, rootState }, payload) {
      const desc = (getters.getManageSortDesc) ? 'desc' : 'asc'
      const user = rootState.auth.userData.data.id
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`user=${user}&filter=${getters.getSearch}&sortby=${getters.getSortBy}&sortdir=${desc}&status=${getters.getStatusApprove}&startdate=${getters.getStartDate}&enddate=${getters.getEndDate}&type=${payload}`)
        axiosDefault.get(`/invoice-download?req=${queryParam.req}`, { responseType: 'arraybuffer' })
          .then(response => {
            // const newData = response.data
            // let blob = new Blob([response.data], { type: 'application/pdf' }),
            // url = window.URL.createObjectURL(blob)
            // window.open(url)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  },
}
